'use client'


//page
import Nav from './Nav';

export default function Teaser() {

    return (
        <>
            <div className="bg-[url('img/back-proces.png')] bg-top bg-cover">
                <Nav />

                <div className="relative isolate px-6 pt-14 lg:px-8">

                    <div className="mx-auto max-w-7xl py-32">
                        <div className="text-left">
                            <h1 className="text-balance text-[80px] leading-[5.5rem] font-semibold tracking-tight text-white  max-w-[80%] ">
                                Teaser vidéo
                            </h1>
                            
                            <div className='mt-10 w-full relative w-content'>
                                <iframe style={{ width: '100%', height: '400px' }} src="https://player.vimeo.com/video/1048855623?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" title="Notre proces - Trailer long"></iframe><script src="https://player.vimeo.com/api/player.js"></script>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
